/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuditTrailResponse } from '../../models/audit-trail-response';

export interface CasesCaseIdAuditGet$Params {
  caseId: string;
}

export function casesCaseIdAuditGet(http: HttpClient, rootUrl: string, params: CasesCaseIdAuditGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AuditTrailResponse>> {
  const rb = new RequestBuilder(rootUrl, casesCaseIdAuditGet.PATH, 'get');
  if (params) {
    rb.path('caseId', params.caseId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuditTrailResponse>;
    })
  );
}

casesCaseIdAuditGet.PATH = '/cases/{caseId}/audit';
